import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CartDetailsRows } from "./CartDetailsRows";

const headerStyle = {
  color: "white",
  textShadow: "1px 3px 1px rgba(0,0,0, 0.4)",
  fontWeight: "black",
  fontFamily: "Noto Sans Display",
  fontSize: "4em",
  padding: "40px",
  borderBottom: "2px solid white",
  marginBottom: "50px",
  marginTop: "20px",
};

// const tableRowDark = {
//   backgroundColor: "rgba(0, 0, 0, 0.15)",
// };

export class CartDetails extends Component {
  getLinkClasses = () => `btn btn-secondary m-1 checkout
        ${this.props.cartItems === 0 ? "disabled" : ""}`;

  render() {
    return (
      <div className="cart-view">
        <h2 className="text-center" style={headerStyle}>
          Your Cart
        </h2>
        <table className="table table-bordered">
          <thead>
            <tr className="table-headers">
              <th>Quantity</th>
              <th>Product</th>
              <th>Price</th>
              <th>Subtotal</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <CartDetailsRows
              cart={this.props.cart}
              cartPrice={this.props.cartPrice}
              updateQuantity={this.props.updateCartQuantity}
              removeFromCart={this.props.removeFromCart}
            />
          </tbody>
        </table>
        <div className="text-center action-buttons">
          <Link className="btn btn-primary m-1 continue" to="/shop">
            Continue Shopping
          </Link>
          <Link className={this.getLinkClasses()} to="/shop/checkout">
            Checkout
          </Link>
        </div>
      </div>
    );
  }
}
